import type { MissionStatus } from '@flipster/apis/v1/rewardHub/types';

import claimableCoinIcon from '../../../assets/images/single-coin-icon/claimable.webp';
import claimedCoinIcon from '../../../assets/images/single-coin-icon/claimed.webp';
import defaultSelectedCoinIcon from '../../../assets/images/single-coin-icon/default.webp';
import disabledCoinIcon from '../../../assets/images/single-coin-icon/disabled.webp';
import { getMissionStatusFlags } from '../../utils';

export function getSingleMissionCoinIconConfig(status: MissionStatus | undefined): { src: string } {
  const { isExpired, isRejected, isClaimed, isSettled, isClaimable } = getMissionStatusFlags(status);

  if (isExpired || isRejected) {
    return {
      src: disabledCoinIcon.src,
    };
  }
  if (isClaimed || isSettled) {
    return {
      src: claimedCoinIcon.src,
    };
  }
  if (isClaimable) {
    return {
      src: claimableCoinIcon.src,
    };
  }
  return {
    src: defaultSelectedCoinIcon.src,
  };
}
